
export const SET_MSG = 'FOLHAR_MSG';
export const SET_EDITAR = 'FOLHAR_EDITAR';
export const SET_LISTA = 'FOLHAR_LISTA';
export const SET_BOLETINS = 'FOLHAR_BOLETINS';